import CostumCarousel from "../components/CostumCarousel";
import Header from "../components/Header";
import Reserve from "./../components/Reservation";
import Support from "./../components/Supports";
import Faq from "./../components/FAQ";
import Discription from "./../components/Description";
import PreFooter from "./../components/PreFooter";
import Footer from "./../components/Footer";
import styled from "styled-components";
import { Outlet } from "react-router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFaq } from "../redux/FaqSlice";
import http from "./../services/httpService";
import config from "./../services/config.json";

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();

  let iranOut = [];
  let bus = [];
  let insideiran = [];
  let hotel = [];
  let train =[];

  useEffect(() => {
    http
      .get(`${config.FaqApi}/faq.json`)
      .then((res) => Object.entries(res.data))
      .then((data) => {
        data.map((each) => {
          let currentData = Object(each[1]);

          switch (currentData.type) {
            case "insideiran":
              insideiran.push(each[1]);
              break;
            case "iranout":
              iranOut.push(each[1]);
              break;
            case "bus":
              bus.push(each[1]);
              break;
            case "hotel":
              hotel.push(each[1]);
              break;
            case "train":
              train.push(each[1]);
              break;
          }
        });

        dispatch(
          setFaq({
            iranOut,
            insideiran,
            train,
            bus,
            hotel
          })
        );
      });

  }, []);

  return (
    <MainContainer>
      <Header />
      <CostumCarousel />
      <Reserve />
      <Outlet />
      <Discription />
      <PreFooter />
      <Footer />
    </MainContainer>
  );
};

export default MainLayout;

const MainContainer = styled.div`
  max-width: 100%;
  overflow-x: hidden;
`;
